module.exports = __webpack_public_path__ + "static/slack-integration-3-7d3d20dbce9afa12408f23c95e77955c.svg";